module.exports = __webpack_public_path__ + "2020fbf2dfe320fb8baa764d0344deba.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/script/svganimations/svg/TECHNOLOGY_SVG.svg
 ** module id = 19
 ** module chunks = 0
 **/